import { render, staticRenderFns } from "./CompUserCRUD.vue?vue&type=template&id=44b577f1"
import script from "./CompUserCRUD.vue?vue&type=script&lang=js"
export * from "./CompUserCRUD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports